import React from 'react';
import type { FC, ReactNode } from 'react';
import { ErrorDetails } from '@wix/cli-ui-kit';
import { isCliError } from '@wix/cli-error';

function getOriginalCause(error?: Error) {
  if (isCliError(error)) {
    return getOriginalCause(error.cause());
  }

  return error;
}

export const ErrorMessage: FC<{
  message: ReactNode;
  cause?: Error;
  explanation?: ReactNode;
  hint?: ReactNode;
}> = ({ message, cause, explanation, hint }) => {
  const originalCause = getOriginalCause(cause);

  return (
    <ErrorDetails
      message={
        originalCause ? (
          <>
            {message} Cause: {originalCause.message}
          </>
        ) : (
          message
        )
      }
      hint={hint}
      explanation={explanation}
    />
  );
};

export const SystemErrorMessage: FC<{
  message: ReactNode;
  explanation?: ReactNode;
  hint?: ReactNode;
}> = ({ message, explanation, hint }) => (
  <ErrorDetails
    message={message}
    explanation={explanation}
    hint={
      hint ??
      'This is probably a temporary system error and has been logged. Try again shortly.'
    }
  />
);
